"use client";

import { useLocalStorage } from "hooks/use-local-storage";
import  { useRef } from "react";

import {
  Oriented,
  mapNameToOriented,
  mapOrientedToName,
} from "@/data/constants/oriented";
import { useLang } from "@/hooks/use-lang";

import { Select } from "ui/core/select";
import { Checkbox } from "ui/widget/checkbox";

import { MobileMenu } from "./MobileMenu";

export const InvestStyleSelect = () => {
  const { t } = useLang();
  const orientedToNameMap = mapOrientedToName({ t });
  const nameToOrientedMap = mapNameToOriented(t);
  const selectRef = useRef<HTMLSelectElement>(null);

  const [investStyle, setInvestStyle] = useLocalStorage<Oriented | null>(
    "investStyle",
    null
  );

  const handleChangeInvestStyle = (investStyle: Oriented | null) => {
    setInvestStyle(investStyle);
    window.dispatchEvent(new CustomEvent("changeInvestStyle", { detail: investStyle }));
  }

  return (
    <>
      <Checkbox
        id="invest-style-checkbox"
        checked={!!investStyle}
        onChange={(e) => {
          if (e) {
            handleChangeInvestStyle(nameToOrientedMap[selectRef.current?.value ?? ""] ?? null);
          } else {
            handleChangeInvestStyle(null);
          }
        }}
        fontSize="0.75rem"
      >
        {t.winwingpt.withStyle}
      </Checkbox>
      <Select
        ref={selectRef}
        value={investStyle ? orientedToNameMap[investStyle] : undefined}
        aria-label="select invest style"
        disabled={!investStyle}
        options={Object.values(orientedToNameMap)}
        className="max-w-xs text-xs sm:text-xs"
        onChange={(e) => {
          handleChangeInvestStyle(nameToOrientedMap[e.target.value]);
        }}
      />
      <MobileMenu />
    </>
  );
};
